import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Search.css';

function Search() {

    const [search, setSearch] = useState('');

    return (
        <div className='search'>
            <input className='search__input' type="text" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} name="search"></input>
            <Link to={search ? `/search/${search}` : '/'}>
                <button className='search__btn'>SEARCH</button>
            </Link>
        </div>
    )
}

export default Search;